// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RpTG8GRkm7nQhF {
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: oy9cwGjg35lb7h;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 120px;
  height: 16px;
  margin-top: 16px;
  margin-bottom: 8px;
}
@keyframes oy9cwGjg35lb7h {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .RpTG8GRkm7nQhF {
    animation: none;
  }
}
.MG4W8uqmecbGeQ {
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: oy9cwGjg35lb7h;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  height: 72px;
  margin-top: 4px;
  margin-bottom: 12px;
}
@keyframes oy9cwGjg35lb7h {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .MG4W8uqmecbGeQ {
    animation: none;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeletonHeaderText": `RpTG8GRkm7nQhF`,
	"shimmer": `oy9cwGjg35lb7h`,
	"skeletonTitleInput": `MG4W8uqmecbGeQ`
};
export default ___CSS_LOADER_EXPORT___;
